/***
 * Central point to manage all engine events
 */
import { AutoCorrectModelPublisher } from './AutoCorrectModelPublisher.js';
import { AutoCorrectModelEvents } from './AutoCorrectModelEvents.js';
import { ModelNotificationEvent } from './ModelNotificationEvent.js';

export class EngineNotificationsService {
  readonly autoCorrectModelPublisher: AutoCorrectModelPublisher;
  readonly autoCorrectModelEvents: AutoCorrectModelEvents;

  private listeners = new Map<string, ((event: ModelNotificationEvent) => void)[]>();

  constructor() {
    this.autoCorrectModelPublisher = new AutoCorrectModelPublisher(this);
    this.autoCorrectModelEvents = new AutoCorrectModelEvents(this);
  }

  notify(eventName: string, event: ModelNotificationEvent) {
    const listeners = this.listeners.get(eventName);
    if (listeners) {
      listeners.forEach(listener => listener(event));
    }
  }

  subscribe<T extends ModelNotificationEvent = ModelNotificationEvent>(eventName: string, listener: (event: T) => void) {
    let listeners = this.listeners.get(eventName);
    if (listeners == undefined) {
      listeners = [];
    }
    listeners.push(listener);
    this.listeners.set(eventName, listeners);
    return () => {
      const index = listeners.findIndex(l => l === listener);
      if (index >= 0) {
        listeners.splice(index, 1);
      }
    }
  }
}
